import { ApolloClient, createHttpLink, InMemoryCache, defaultDataIdFromObject } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import Auth from '@aws-amplify/auth'
import { persistCache, LocalStorageWrapper } from 'apollo3-cache-persist'
// import possibleTypes from './fragmentTypes.json'

const gqlURL = process.env.REACT_APP_CMSGQL_PATH
// console.debug('GRAPHQL_URL = ', gqlURL)

const httpLink = createHttpLink({ uri: gqlURL })

const authLink = setContext(async (_, { headers }) => {
  const cognitoUser = await Auth.currentAuthenticatedUser()
  const token = cognitoUser.getSignInUserSession().getAccessToken().getJwtToken()
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      Authorization: token,
    },
  }
})

const cache = new InMemoryCache({
  // possibleTypes,
  dataIdFromObject(responseObject) {
    if (!responseObject.id && responseObject?.metadata?.cwid) {
      // use metadata.cwid as cache id
      return `${responseObject.__typename}:${responseObject.metadata.cwid}`
    } else {
      return defaultDataIdFromObject(responseObject)
    }
  },
  typePolicies: {
    Query: {
      fields: {
        GlossaryItems: {
          merge(_existing, incoming) {
            return incoming
          },
        },
        PerformanceInsightConnection: {
          merge(_existing, incoming) {
            return incoming
          },
        },
      },
    },
  },
})

// await before instantiating ApolloClient, else queries might run before the cache is persisted
await persistCache({
  cache,
  storage: new LocalStorageWrapper(window.localStorage),
  maxSize: 5 * 1024 * 1024,
  debug: true,
})

export const apolloClient = new ApolloClient({
  connectToDevTools: true,
  link: authLink.concat(httpLink),
  cache,
})
